module.exports = __webpack_public_path__ + "static/media/baja.7db26740.png";